import styled from '@emotion/styled';
import { gsColors } from '../../../styles/Variables';
import { mq } from '../../../helpers'

export const MembershipSection = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
  align-items: center;

  .hero-class {
    width: 100%;
    .hero-container {
      width: 100%;
      max-width: 1600px;
  
      .hero-container-inner {
        width: 100%;

        ${mq('max', '768px')} {
          height: 900px;
        }

        .content, .image-placeholder {
          min-width: 50%;
        }
      }
  
    }
  }


  .membership-items-section {
    margin-top: 88px;
    margin-bottom: 50px;
    max-width: 620px;

    ${mq('max', '768px')} {
      margin: 0;
      max-width: 100%;
      width: 100%;
      padding: 40px 16px;
    }

    .intro-offers{
      display: flex; 
      flex-direction: column; 
    }

    .disclaimer {
      text-align: left;
      margin: 37px 0;
    }

    .cards-container{
      gap: 10px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;

      ${mq('max', '826px')} {
        flex-direction: column;
        flex-wrap: nowrap;
      }
    }

    .select-product-wrapper {
      margin-top: 40px;
      button {

        ${mq('max', '768px')} {
          max-width: 100%;
        }
      }
    }
  }

  .membership-perks-section {
    width: 100%;
    max-width: 1600px;
    padding: 50px 88px;

    ${mq('max', '768px')} {
      padding: 32px 16px;
    }

    .perk-items-wrapper {
      display: flex;
      gap: 16px;
      margin: 32px 0;

      ${mq('max', '768px')} {
        flex-direction: column;
        gap: 30px;
      }
      
      .membership-perk-item {
        text-align: left;
        flex-basis: 33%;
      }
    }
  }

`

export const CardWrapper = styled.div`
  width: 100%;

  &:hover {
    cursor: pointer;
  }

  .card-container {
    transition: all 0.1s ease;
    border: 1px solid ${gsColors.lightTangerine};
    padding: 30px 20px;
    display: flex;
    flex-direction: column;

    .card-content {
      display: flex;
      justify-content: space-between;
      margin-bottom: 10px;

      p:first-child {
        text-align: left;
      }
    }

    .card-footer {
      text-align: left;
    }
  }

  .selected {
    border: 1px solid ${gsColors.sunsetOrange};
  }
  

`

export const FeaturedCardDiv = styled.div`
  border: 1px solid ${gsColors.lightTangerine};
  padding: 23px 18px 37px;

  .membership-perks {
    text-align: left;
    margin: 18px 0 33px;

    ul {
      li {
        position: relative;
        padding-left: 20px;
        color: ${gsColors.meredithGrey};

        &::before {
            content: '•'; /* Bullet point character */
            position: absolute;
            left: 0;
            color: ${gsColors.meredithGrey}; 
          }
      }
    }
  }

  .price-info {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    .featured-item-price {
      display: flex;
      gap: 10px;

      .renewal-price {
        color: ${gsColors.greyPoupon};
        text-decoration: line-through;
      }
    }
  }

  .featured-card-footer {
    width: 100%;
    display: flex;
    justify-content: center;

    .footer-content {
      max-width: 60%;
      display: flex;
      flex-direction: column;
      gap: 30px;
      
      ${mq('max', '768px')} {
        max-width: 100%;
        width: 100%;
      }
    }
  }

`
